import {ValueObject} from '@s-ui/domain'

import {QueryParamSharedValueObject} from '../../shared/ValueObjects/QueryParamSharedValueObject.js'
import {FilterRangeSearchValueObject} from './FilterRangeSearchValueObject.js'

export class FilterElectricBatteryCapacitySearchValueObject extends ValueObject {
  #batteryCapacity

  constructor({batteryCapacity}) {
    super()
    this.#batteryCapacity = batteryCapacity
  }

  static create({batteryCapacity}) {
    return new FilterElectricBatteryCapacitySearchValueObject({
      batteryCapacity: FilterRangeSearchValueObject.create(batteryCapacity)
    })
  }

  static createWithDefaultValue({config, batteryCapacity}) {
    const {DEFAULT_ELECTRIC_BATTERY_CAPACITY_SEARCH} = config.get('searchFilters')

    return new FilterElectricBatteryCapacitySearchValueObject({
      batteryCapacity: FilterRangeSearchValueObject.create({
        from: batteryCapacity?.from || DEFAULT_ELECTRIC_BATTERY_CAPACITY_SEARCH.from,
        to: batteryCapacity?.to || DEFAULT_ELECTRIC_BATTERY_CAPACITY_SEARCH.to
      })
    })
  }

  static createQueryParams({config, batteryCapacity}) {
    const {DEFAULT_ELECTRIC_BATTERY_CAPACITY_SEARCH, FILTER_NAMES, FILTER_QUERY_PARAMS} = config.get('searchFilters')

    return new FilterElectricBatteryCapacitySearchValueObject({
      batteryCapacity: {
        from: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY].from,
          value: batteryCapacity?.from || DEFAULT_ELECTRIC_BATTERY_CAPACITY_SEARCH.from
        }),
        to: QueryParamSharedValueObject.createForSingle({
          key: FILTER_QUERY_PARAMS[FILTER_NAMES.ELECTRIC_BATTERY_CAPACITY].to,
          value: batteryCapacity?.to || DEFAULT_ELECTRIC_BATTERY_CAPACITY_SEARCH.to
        })
      }
    })
  }

  get isEmpty() {
    return this.#batteryCapacity.isEmpty
  }

  get queryParams() {
    return {
      ...(!this.#batteryCapacity.from.isEmpty && {...this.#batteryCapacity.from.queryParam}),
      ...(!this.#batteryCapacity.to.isEmpty && {...this.#batteryCapacity.to.queryParam})
    }
  }

  get value() {
    return this.#batteryCapacity.value
  }

  toJSON() {
    return {
      batteryCapacity: this.#batteryCapacity.toJSON()
    }
  }
}
